module.exports = __webpack_public_path__ + "media/cloud_loop.9c10ea60.mp4";